import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.72 5.048a.625.625 0 0 1 .68.135l8.75 8.75 1.667 1.667a.625.625 0 0 1-.884.884L12.45 15H5.625a2.292 2.292 0 0 1-2.292-2.292V5.625c0-.253.153-.48.386-.577Zm7.48 8.702L4.583 7.134v5.574c0 .576.467 1.042 1.042 1.042H11.2Zm-.158-7.5H8.125a.625.625 0 0 1 0-1.25h2.917a2.292 2.292 0 0 1 2.291 2.265l2.402-1.351a.625.625 0 0 1 .932.544v7.084a.625.625 0 0 1-.932.544l-3.333-1.875a.625.625 0 0 1-.319-.544V7.292c0-.576-.466-1.042-1.041-1.042Zm2.291 2.449V11.3l2.084 1.172V7.527l-2.084 1.172Z" fill="currentColor" />' }
  })
);